"use client";

import { TEMPLATES } from "@/lib/invoice/templates";
import InvoicePreview from "./InvoicePreview";
import { cx } from "./ui";

// Visual template chooser: each card renders a live mini-preview of `invoice`
// (or a small sample) in that template with the chosen brand colours.
export default function TemplatePicker({ value, onChange, invoice, data, allowDefault, defaultLabel = "Use default" }) {
  const sample = invoice || {
    number: "AT/2026-27/13",
    docType: "invoice",
    date: "2026-08-31",
    dueDate: "2026-09-15",
    currency: "GBP",
    taxMode: "export",
    billTo: { name: "Client Company Ltd", address: "1 High Street", country: "United Kingdom" },
    items: [
      { description: "SEO – 20 keywords", qty: 1, rate: 183 },
      { description: "Google Ads management", qty: 1, rate: 100 },
      { description: "Website maintenance", qty: 1, rate: 95 },
    ],
  };
  const preview = { ...sample, items: (sample.items || []).slice(0, 6) };

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-6">
      {allowDefault && (
        <button
          type="button"
          onClick={() => onChange("")}
          className={cx(
            "flex min-h-[120px] flex-col items-center justify-center rounded-lg border-2 p-2 text-xs text-slate-600",
            !value ? "border-brand-600 bg-brand-50" : "border-dashed border-slate-300 hover:border-slate-400"
          )}
        >
          {defaultLabel}
        </button>
      )}
      {Object.entries(TEMPLATES).map(([key, t]) => (
        <button
          type="button"
          key={key}
          onClick={() => onChange(key)}
          className={cx(
            "group overflow-hidden rounded-lg border-2 bg-white text-left transition",
            value === key ? "border-brand-600 ring-2 ring-brand-100" : "border-slate-200 hover:border-slate-400"
          )}
        >
          <div className="relative h-40 overflow-hidden bg-slate-100">
            <div className="pointer-events-none absolute left-1/2 top-2 origin-top -translate-x-1/2 scale-[0.2] shadow">
              <InvoicePreview invoice={{ ...preview, template: key }} data={data} thumbnail />
            </div>
          </div>
          <div className="border-t border-slate-100 px-2 py-1.5">
            <div className="text-xs font-semibold text-slate-800">{t.label}</div>
            <div className="truncate text-[10px] text-slate-500">{t.desc}</div>
          </div>
        </button>
      ))}
    </div>
  );
}
